import { GridColDef, GridExpandMoreIcon } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  GKClientDataGrid,
  Grid2,
  Typography,
} from "components";
import dayjs from "dayjs";
import { useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const PortfolioLimits = () => {
  const { id } = useParams();
  const [expanded, setExpanded] = useState<number>(-1);

  const { data } = useQuery({
    queryKey: ["GET_PORTFOLIO_LIMITS"],
    queryFn: () => axiosInstance.get(`super_admin/${id}/get-portfolio-limit/`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Count", "count", 120, 1),
    },
    {
      ...extraColumnsField("Type", "type", 120, 1),
    },
    {
      ...extraColumnsField("Updated Count", "updatedCount", 120, 1),
      valueGetter: (row) => row?.row?.updatedCount || "-",
    },
    {
      ...extraColumnsField("Date", "createdAt", 120, 1),
      valueFormatter: (params) => dayjs(params?.value).format("DD MMM YYYY"),
      valueGetter: (row) => row?.row?.createdAt || "N/A",
    },
  ];

  return (
    <Accordion
      disableGutters
      onChange={() => {
        setExpanded(expanded === 0 ? -1 : 0);
      }}
      style={{
        border: `solid 1px var(--neutral-100)`,
        borderRadius: "8px",
        boxShadow: "none",
        background: "none",
      }}
    >
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        sx={{
          "& .MuiAccordionSummary-content": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          },
        }}
      >
        <Typography
          fontSize={16}
          fontWeight={600}
          textTransform="none"
          color={"var(--primary-900)"}
        >
          Portfolio Limits
        </Typography>
      </AccordionSummary>
      <Divider />
      <AccordionDetails
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Grid2 container size={12} spacing={1}>
          <Grid2 size={12}>
            <GKClientDataGrid
              // loading={isLoading}
              columns={columns}
              rows={data?.data?.data || []}
              showFiltersButton={false}
            />
          </Grid2>
        </Grid2>
      </AccordionDetails>
    </Accordion>
  );
};

export default PortfolioLimits;
